module.exports = __webpack_public_path__ + "static/media/Селянин Евгений Романович Как купец Сухов барина благотворительности научил Алтайский край-1.png";